import { defineComponent as B, useAttrs as C, inject as N, computed as o, openBlock as s, createElementBlock as i, normalizeClass as h, unref as n, createVNode as R, mergeProps as T, withCtx as k, renderSlot as z, toDisplayString as A, createCommentVNode as x } from "vue";
import { RadioSymbol as _, RadioSize as D } from "./novoui-vuejs59.js";
import { ERadioBorderVariants as E, getRadioBorderStyleClasses as P } from "./novoui-vuejs55.js";
import U from "./novoui-vuejs17.js";
const $ = {
  key: 0,
  class: "touch-area-assistive-text"
}, q = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "NRadioBorder",
  props: {
    name: {},
    assistiveText: {},
    value: { type: [String, Number, Boolean] },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    label: {},
    disabled: { type: Boolean },
    error: { type: Boolean },
    variant: { default: E.fill }
  },
  emits: ["update:modelValue"],
  setup(d, { emit: u }) {
    const t = d, m = u, { class: c, ...p } = C(), a = N(_, {}), f = o(() => a && a.name || t.name), v = o(() => a && a.disabled || t.disabled), b = o(() => a && a.error || t.error), V = o(() => typeof t.value > "u" ? t.label : t.value), r = o({
      get: () => t.modelValue ?? a.selected,
      set: (e) => {
        t.modelValue !== void 0 && m("update:modelValue", e), a.onChange && (a == null || a.onChange(e));
      }
    });
    function S(e) {
      var l;
      ((l = e.target) == null ? void 0 : l.nodeName) !== "INPUT" && (r.value = t.value, e.preventDefault(), e.stopPropagation());
    }
    const g = o(() => P(t, a));
    return (e, l) => (s(), i("div", {
      onClick: S,
      "tab-index": 0,
      class: h([g.value, { "touch-area-selected": r.value === V.value }, n(c)])
    }, [
      R(U, T({
        size: n(D).large,
        modelValue: r.value,
        "onUpdate:modelValue": l[0] || (l[0] = (y) => r.value = y),
        name: f.value,
        error: b.value,
        disabled: v.value,
        value: e.value,
        label: e.label
      }, p), {
        default: k(() => [
          z(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["size", "modelValue", "name", "error", "disabled", "value", "label"]),
      e.assistiveText && e.assistiveText.trim() ? (s(), i("span", $, A(e.assistiveText), 1)) : x("", !0)
    ], 2));
  }
});
export {
  q as default
};
